var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"aft-loading",attrs:{"src":require("@/assets/img/aft-loading.png"),"alt":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }